import {msg} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';

@customElement('arc-choose-plan-button')
export class ChoosePlanButton extends LitElement {

	static properties = {
		plan: {type: Object},
		currentPlan: {type: Object},
		onSelect: {type: Function},
		alternateBillingCycle: {type: Boolean},
	};

	render() {
		const canChoose = (this.plan.canChoose || this.isAlternateBillingCycle) && !this.plan.isUpgrade; // fixme no upgrades for now!!!
		const isCurrent = this.plan.id === this.currentPlan?.id;
		let actionLabel = msg('choose_plan_select_action');
		if (this.plan.isUpgrade) {
			actionLabel = msg('choose_plan_upgrade_action');
		}
		if (this.plan.isDowngrade) {
			actionLabel = msg('choose_plan_downgrade_action');
		}
		if (this.alternateBillingCycle) {
			actionLabel = msg('choose_plan_alternate_billing_cycle_action');
		}
		if (this.plan.priceOnRequest) {
			actionLabel = msg('choose_plan_request_price');
			return html`<a href="mailto:support@aakio.info?subject=Custom AAKIO Plan Enquiry">	<arc-button
				title="${actionLabel}"
				type="primary"
				.additionalInfo="${false}"
			></a>`;
		}
		return when(canChoose, () => html`
			<arc-button
				@click=${() => this.onSelect(this.plan, this.isAlternateBillingCycle)}
				title="${actionLabel}"
				type="primary"
				.additionalInfo="${false}"
			>
			</arc-button>
    `, () => when(isCurrent, () => (
			html`<h4>${msg('choose_plan_current')}</h4>`
		)));
	}
}
